import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import Reveal from "@/components/layout/Reveal";
import SectionLabel from "@/components/layout/SectionLabel";

export const DualAudienceSection = () => {
  return (
    <section className="py-20 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <Reveal className="max-w-3xl">
          <SectionLabel>For everyone in the project</SectionLabel>
          <h2 className="font-heading mt-4 text-3xl sm:text-4xl font-bold text-[#0B132B]">
            Whether you're a homeowner, builder or installer.
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          {[
            {
              tag: "For Homeowners",
              title: "Upgrade your home, lower your bills.",
              body: "Friendly guidance, photo-based pre-assessment, same-day quotes where possible, transparent pricing and a clear pathway to a smarter home.",
              cta: "Get Free Assessment",
              to: "/free-home-assessment",
              accent: "bg-[#10B981]",
              tagBg: "bg-[#10B981]/15 text-[#059669]",
            },
            {
              tag: "For Builders & Installers",
              title: "Project-ready hot water solutions.",
              body: "Talk to AeroMax Energy about supply, install pathways, technical support and project pricing for new builds and renovations.",
              cta: "Talk to Our Team",
              to: "/contact",
              accent: "bg-[#0B132B]",
              tagBg: "bg-[#0B132B]/10 text-[#0B132B]",
            },
          ].map((a, i) => (
            <Card key={i} className="rounded-3xl p-8 border-[#E2E8F0] bg-white hover:shadow-xl transition-all">
              <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-[11px] font-semibold tracking-widest uppercase ${a.tagBg}`}>
                {a.tag}
              </span>
              <h3 className="font-heading mt-4 text-2xl sm:text-3xl font-bold text-[#0B132B]">{a.title}</h3>
              <p className="mt-3 text-[#475569] leading-relaxed">{a.body}</p>
              <Link
                to={a.to}
                className={`mt-6 inline-flex items-center gap-2 rounded-full ${a.accent} hover:opacity-90 text-white px-5 py-3 font-semibold text-sm transition-all`}
              >
                {a.cta} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
